import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, getregistrationCategoryType, getpaymentType, getregType, getoccupancyType, geteventType, getcurrencyType, getcountries, getReceiptId, getprogramManager, getseriesType, getconferenceEvent, getwebinarEvent} from '../../../services/event/paymentReceiptForm/paymentReceiptServices';
import { Modal, Button, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';
import Swal from 'sweetalert2';

const subDomain = localStorage.getItem('sub_domain') || '';

const PaymentReceipt = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({
    id: '',
    accommodation: false,  
    accommodation_status : '',
    billing_address : '',
    billing_countries : '',
    billing_email : '',
    billing_full_name : '',
    billing_phone_no : '',
    currency_type : '',
    date_of_payment : '',
    event_date : '',
    event_title : '',
    event_type : '',
    no_of_ticket : '',
    occupancy_type : '',
    payment_id : '',
    payment_type : '',
    participant_type: 'paid',
    pdf_status : 0,
    receipt_date : '',
    refund_status : 0,
    reg_amount : '',
    reg_category : '',
    reg_type : '',
    series : '',
    shipping: false,
    shipping_address : '',
    shipping_countries : '',
    shipping_email : '',
    shipping_full_name : '',
    shipping_phone_no : '',
    sub_domain : subDomain,
    subject : '',
    total_no_of_nights : '',
    transaction_id : '',
    updatedAt : ''
  });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  // const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  // const [selectedData, setSelectedData] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});

  // Filter States
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [countryFilter, setCountryFilter] = useState('');
  const [dropdownData, setDropdownData] = useState({
    registrationCategoryType: [],
    paymentType: [],
    regType: [],
    occupancyType: [],
    eventType: [],
    currencyType: [],
    countries: [],
  });
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [filteredRegistrationCategories, setFilteredRegistrationCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Fetch all dropdown data
  const fetchDropdownData = useCallback(async () => {
    try {
      const [regCategory, payment, reg, occupancy, event, currency, country] = await Promise.all([
        getregistrationCategoryType(),
        getpaymentType(),
        getregType(),
        getoccupancyType(),
        geteventType(),
        getcurrencyType(),
        getcountries(),
      ]);
 
      setDropdownData({
        registrationCategoryType: regCategory,
        paymentType: payment,
        regType: reg,
        occupancyType: occupancy,
        eventType: event,
        currencyType: currency,
        countries: country,
      });
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  }, []);
 
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({sub_domain: subDomain });
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);
  const fetchReceiptId = useCallback(async (type) => {
      try {
          const result = await getReceiptId({ sub_domain: subDomain, type });
          console.log('Result:', result);
   
          if (result && result[type]) {
            setForm((prevForm) => ({
              ...prevForm,
              payment_id: result[type]
            }));
          }
      } catch (error) {
          console.error('Error fetching payment ID:', error);
      }
  }, []);

  const fetchseriesType = useCallback(async () => {
      try {
        const data = await getseriesType({ sub_domain: subDomain });
        if (data && data.length > 0) {
          const seriesInfo = data[0]; // Assuming you're using the first item
          setForm(prev => ({
            ...prev,
            series: seriesInfo.series || ''       
          }));
          console.log("Setting series:", seriesInfo.series);

        }
      } catch (error) {
        console.error('Failed to fetch series info:', error);
      }
    }, []);
   
 
 
  useEffect(() => {
    
    // fetchReceiptId();
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      await fetchDropdownData();
      await fetchseriesType(); 
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
  
    fetchDataAsync();
 
  }, [fetchData, fetchDropdownData, fetchReceiptId, fetchseriesType]);
     
  const handleChange =async (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
    // Handle event_type-specific logic
      if (name === 'event_type') {
        let eventData = [];
        try {
          if (value.toLowerCase() === 'conference') {
            eventData = await getconferenceEvent({ sub_domain: subDomain });
          } else if (value.toLowerCase() === 'webinar') {
            eventData = await getwebinarEvent({ sub_domain: subDomain });
          }

          if (eventData.length > 0) {
            const event = eventData[0]; // Assume first result
            const eventDate = formatEventDate(
              event.from_date,
              event.to_date,
              value.toLowerCase() === 'conference' ? event.venue : ''
            );

            setForm((prev) => ({
              ...prev,
              event_title: event.event_title,
              event_date: eventDate
            }));
          }
        } catch (error) {
          console.error('Error loading event details:', error);
        }
      }
    // If the Registration Type changes, filter the Registration Category
    if (name === "reg_type") {
        if (value) {
            const filteredCategories = dropdownData.registrationCategoryType.filter(
                (item) => item.type === value
            );
            setFilteredRegistrationCategories(filteredCategories);
            setShowCategoryDropdown(filteredCategories.length > 0); // Show only if categories exist
            // Reset category when type changes
            setForm((prev) => ({ ...prev, reg_category: "" }));
        } else {
            setFilteredRegistrationCategories([]);
            setShowCategoryDropdown(false); // Hide the select input
        }
    }
    
  };

  //event title and date and venue
 const formatEventDate = (fromDate, toDate, venue = '') => {
  const from = new Date(fromDate);
  const year = from.getFullYear();

  const options = { month: 'long', day: '2-digit' };
  const fromFormatted = from.toLocaleDateString('en-US', options);

  let range = `${fromFormatted}, ${year}`;

  if (toDate) {
    const to = new Date(toDate);

    // Only show range if fromDate and toDate are different
    if (from.toDateString() !== to.toDateString()) {
      const toFormatted = to.toLocaleDateString('en-US', { day: '2-digit' });
      range = `${fromFormatted}-${toFormatted}, ${year}`;
    }
  }

  return venue ? `${range} | ${venue}` : range;
};

  const handleShippingToggle = (e) => {
    const isChecked = e.target.checked;
    setForm((prevForm) => ({
      ...prevForm,
      shipping: isChecked,
      // Only clear shipping fields if enabling shipping
      ...(isChecked ? {
        shipping_full_name: "",
        shipping_email: "",
        shipping_phone_no: "",
        shipping_countries: "",
        shipping_address: ""
      } : {
        // When disabling shipping, copy billing details to shipping
        shipping_full_name: prevForm.billing_full_name,
        shipping_email: prevForm.billing_email,
        shipping_phone_no: prevForm.billing_phone_no,
        shipping_countries: prevForm.billing_countries,
        shipping_address: prevForm.billing_address
      })
    }));
  };
 
  const validateForm = () => {
    const newErrors = {};
    if (!form.event_type) newErrors.event_type = 'Event Type is required.';
    if (!form.payment_type) newErrors.payment_type = 'Payment Type is required.';
    if (!form.receipt_date) newErrors.receipt_date = 'Receipt Date is required.';
    if (!form.billing_full_name) newErrors.billing_full_name = 'Billing Full Name is required.';
    if (!form.billing_email) newErrors.billing_email = 'Billing Email is required.';
    if (!form.billing_phone_no) newErrors.billing_phone_no = 'Billing Phone is required.';
    if (!form.billing_countries) newErrors.billing_countries = 'Billing Country is required.';
    if (!form.billing_address) newErrors.billing_address = 'Billing Address is required.';
    if (!form.date_of_payment) newErrors.date_of_payment = 'Date of Payment is required.';
    if (!form.currency_type) newErrors.currency_type = 'Currency is required.';
    if (!form.reg_amount) newErrors.reg_amount = 'Registration Amount is required.';
    if (!form.no_of_ticket) newErrors.no_of_ticket = 'Number of Tickets is required.';
    if (!form.reg_type) newErrors.reg_type = 'Registration Type is required.';

    if (showCategoryDropdown && !form.reg_category) {
      newErrors.reg_category = 'Registration Category is required.';
    }
  
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (form.billing_email && !emailRegex.test(form.billing_email)) {
      newErrors.billing_email = 'Invalid email format.';
    }
  
    if (Boolean(form.shipping)) {
      if (!form.shipping_full_name) newErrors.shipping_full_name = 'Shipping Full Name is required.';
      if (!form.shipping_email) newErrors.shipping_email = 'Shipping Email is required.';
      if (!form.shipping_phone_no) newErrors.shipping_phone_no = 'Shipping Phone No is required.';
      if (!form.shipping_address) newErrors.shipping_address = 'Shipping Address is required.';
      if (!form.shipping_countries) newErrors.shipping_countries = 'Shipping Country is required.';
    }
  
    // Accommodation fields
    if (Boolean(form.accommodation)) {
      if (!form.accommodation_status) newErrors.accommodation_status = 'Accommodation Status is required.';
      if (!form.occupancy_type) newErrors.occupancy_type = 'Occupancy Type is required.';
      if (!form.total_no_of_nights) newErrors.total_no_of_nights = 'Number of Nights is required.';
    }
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
     
      const formData = {
          ...form,
          participant_type: form.participant_type || 'paid',
          accommodation: form.accommodation ? '1' : '0',
          shipping: form.shipping ? '1' : '0',
        };

      // If accommodation is disabled, clear the related fields
      if (!form.accommodation) {
        formData.accommodation_status = "";
        formData.occupancy_type = "";
        formData.total_no_of_nights = "";
      }
      // Handle shipping if disabled (same logic as before)
      if (!form.shipping) {
        formData.shipping_full_name = formData.billing_full_name;
        formData.shipping_email = formData.billing_email;
        formData.shipping_phone_no = formData.billing_phone_no;
        formData.shipping_countries = formData.billing_countries;
        formData.shipping_address = formData.billing_address;
      }
 
      // Submit the form data
      if (modalType === 'add') {
        await addData(formData);
      } else if (modalType === 'edit') {
        await updateData({ ...formData, pdf_status: 0 }); // ✅ Set pdf_status to 0 on update

      }
 
      fetchData();
      setShowModal(false);
     // ✅ Show success alert with auto-close
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: `Payment receipt ${modalType === 'add' ? 'added' : 'updated'} successfully!`,
          timer: 2000, // 2 seconds
          showConfirmButton: false,
        });
    
      } catch (error) {
        console.error('Error during form submission:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong while submitting the form!',
        });
      }
  };
 
 
  // const handleDelete = async () => {
  //   if (selectedData) {
  //     // Optimistically remove the data from the list
  //     setDataList((prev) => prev.filter((data) => data.id !== selectedData.id));
  //     // Proceed with the actual delete request
  //     await deleteData(selectedData);
  //     setShowDeleteConfirmModal(false);
  //   }
  // };
  //today date
 const getTodayDate = () => {
   return new Date().toISOString().split('T')[0]; // returns 'YYYY-MM-DD'
  };
  const todayDate = getTodayDate(); 

  const openModal = async (type, data = {
    id: '',
    accommodation: '',
    accommodation_status: '',
    billing_address: '',
    billing_countries: '',
    billing_email: '',
    billing_full_name: '',
    billing_phone_no: '',
    currency_type: '',
    date_of_payment: '',
    event_date: '',
    event_title: '',
    event_type: '',
    no_of_ticket: '',
    occupancy_type: '',
    payment_id: '',
    payment_type: '',
    participant_type: 'paid',
    receipt_date: todayDate,
    reg_amount: '',
    reg_category: '',
    reg_type: '',
    series: '',
    shipping: '',
    shipping_address: '',
    shipping_countries: '',
    shipping_email: '',
    shipping_full_name: '',
    shipping_phone_no: '',
    sub_domain: subDomain,
    subject: '',
    total_no_of_nights: '',
    transaction_id: '',
    updatedAt: ''
  }) => {
    setErrors({});
    setModalType(type);

    // ✅ Clone and normalize accommodation/shipping as booleans
    const normalizedData = {
      ...data,
      accommodation: data.accommodation === '1' || data.accommodation === 1 || data.accommodation === true,
      shipping: data.shipping === '1' || data.shipping === 1 || data.shipping === true,
    };

    // ✅ Clear accommodation fields if accommodation is false
    if (!normalizedData.accommodation) {
      normalizedData.accommodation_status = '';
      normalizedData.occupancy_type = '';
      normalizedData.total_no_of_nights = '';
    }

    // ✅ Copy billing info to shipping if shipping toggle is off
    if (!normalizedData.shipping) {
      normalizedData.shipping_full_name = normalizedData.billing_full_name || '';
      normalizedData.shipping_email = normalizedData.billing_email || '';
      normalizedData.shipping_phone_no = normalizedData.billing_phone_no || '';
      normalizedData.shipping_countries = normalizedData.billing_countries || '';
      normalizedData.shipping_address = normalizedData.billing_address || '';
    }

    // ✅ Filter registration categories
    if (normalizedData?.reg_type) {
      const filteredCategories = dropdownData.registrationCategoryType.filter(
        (item) => item.type === normalizedData.reg_type
      );
      setFilteredRegistrationCategories(filteredCategories);
      setShowCategoryDropdown(filteredCategories.length > 0);
    } else {
      setFilteredRegistrationCategories([]);
      setShowCategoryDropdown(false);
    }

    // ✅ Handle "add" mode (fetch receipt ID and series)
    if (type === 'add') {
        const data = await getprogramManager({ sub_domain: subDomain });
       // 🚫 Check if no program manager is found
        if (!data || data.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Program Manager Not Found',
          text: 'No Program Manager details found. Please update the Program Manager details.',
          showCancelButton: true,
          confirmButtonText: 'Update Now',
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        }).then((result) => {
          if (result.isConfirmed) {
            // Redirect to program manager page
            window.location.href = `/programManager`; // ⬅️ replace baseurl with your actual base URL if needed
          }
        });
        return;
      }

      const status = data?.[0]?.status ?? true; // fallback to 1 if undefined
      //Show alert and stop if inactive
      if (status === false) {
        Swal.fire({
          icon: 'warning',
          title: 'Program Manager Inactive',
          text: 'Your Program Manager details are inactive. Please contact the admin.',
          confirmButtonColor: '#3085d6'
        });
        return;
      }
      
      try {
        const result = await getReceiptId({ sub_domain: normalizedData.sub_domain, type: 'payment' });
        if (result?.payment_id) {
          normalizedData.payment_id = result.payment_id;
        }

        const seriesData = await getseriesType({ sub_domain: subDomain });
        if (seriesData?.length > 0) {
          normalizedData.series = seriesData[0].series;
        }
      } catch (error) {
        console.error("Error fetching receipt ID:", error);
      }
    }

    // ✅ Finally set form and show modal
    setForm(normalizedData);
    setShowModal(true);
  };

 
  // const openDeleteConfirmModal = (data) => {
  //   setSelectedData(data);
  //   setShowDeleteConfirmModal(true);
  // };
 
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };
 
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const getCurrencySymbol = (currencyCode) => {
    switch (currencyCode?.toUpperCase()) {
      case 'USD': return '$';
      case 'EUR': return '€';
      case 'INR': return '₹';
      case 'GBP': return '£';
      case 'RUB': return '₽';
      case 'THB': return '฿';
      default: return currencyCode || '';
    }
  };

   //based country code append country name
  const getCountryName = (code) => {
  const country = dropdownData.countries.find(c => c.code === code);
  return country ? country.name : code;
  };

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
  const startDateObj = startDate ? new Date(startDate) : null;
  const endDateObj = endDate ? new Date(endDate) : null;

  return dataList
    .filter((data) => {
      // Text-based search
      const matchesText =
        data.sub_domain.toLowerCase().includes(searchText.toLowerCase()) ||
        data.reg_amount.toString().includes(searchText.toLowerCase()) ||
        data.billing_full_name.toLowerCase().includes(searchText.toLowerCase()) ||
        data.currency_type.toLowerCase().includes(searchText.toLowerCase()) ||
        data.billing_countries.toLowerCase().includes(searchText.toLowerCase()) ||
        data.event_type.toLowerCase().includes(searchText.toLowerCase()) ||
        data.date_of_payment.toString().includes(searchText.toLowerCase());

      // Date range filtering
      const dateofpayment = data.date_of_payment ? new Date(data.date_of_payment) : null;

      const inDateRange = (startDateObj && endDateObj)
        ? dateofpayment >= startDateObj && dateofpayment <= endDateObj
        : true;

      // Country filtering
      const matchCountry = !countryFilter || data.billing_countries === countryFilter;

      return matchesText && inDateRange && matchCountry;
    })
    .sort((a, b) => new Date(b.date_of_payment) - new Date(a.date_of_payment)); // Always sort by date descending
}, [dataList, searchText, startDate, endDate, countryFilter]);

 
  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '60px',
    },
    {
      name: 'Date of Payment',
      selector: (row) => row.date_of_payment,
      sortable: true,
      wrap: true,
    },

    {
      name: 'Name',
      selector: (row) => row.billing_full_name,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Country',
      selector: (row) => getCountryName(row.billing_countries),
      sortable: true,
      wrap: true,
    },
    {
      name: 'Reg Amount',
      selector: (row) => {
        const currencySymbol = getCurrencySymbol(row.currency_type);
        return <b className='fs-4'>{currencySymbol} {row.reg_amount}</b>;
      },
      sortable: true,
      wrap: true, 
    },
    {
      name: 'Event Type',
      selector: (row) => row.event_type,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Currency Type',
      selector: (row) => row.currency_type,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
          {/* <Button variant="danger" size="sm" onClick={() => openDeleteConfirmModal(row)} > Delete </Button> */}
        </div>
      ),
    },
  ];
 
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        <div className=" row m-3 d-flex flex-column gap-3 ">
          <div className="d-flex gap-2">
            {/* Dropdown for Filters */}
            <div className="col-md-2">
            <span className='fs-5 text-dark'>Countries</span>
            <select
              className="form-control"
              value={countryFilter}
              onChange={(e) => setCountryFilter(e.target.value)}
            >
              <option value="">All Countries</option>
              {dropdownData.countries.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>

            {/* Start Date and End Date Input */}
            <div className="col-md-2">
              <span className='fs-5 text-dark'>Start Date</span>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <span className='fs-5 text-dark'>End Date</span>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>      
        </div>
        {loading ? (
        <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <Spinner /> {/* Centered Spinner */}
          </div>
                  ) :(
          <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
            <p className='fs-4 text-dark'>Receipt Generation / Payment Receipt Form</p>
            </div>
            <div className="col-4 text-end">
            <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
            </button>
            </div>
          </div>
 
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 50, 100, 200, 500]}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />
 
          {/* Modal for Add/Edit data */}
          <Modal show={showModal} backdrop="static" className='modal-xl' onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <div className='row'>
                <Form.Group className="col-md-3 mb-3">
                <Form.Label className='fs-5 text-dark'>Payment Receipt ID<span className="text-danger fs-4"> * </span></Form.Label>
                <Form.Control type="text" name="payment_id" value={form.payment_id}  />
                </Form.Group>
                <Form.Group className="col-md-2 mb-3">
                  <Form.Label className='fs-5 text-dark'>Series <span className="text-danger fs-4"> * </span></Form.Label>
                    <Form.Control type="text" name="series" value={form.series} readOnly />
                </Form.Group>

                <Form.Group className="col-md-2 mb-3">
                  <Form.Label className='fs-5 text-dark'>Receipt Date<span className="text-danger fs-4"> * </span></Form.Label>
                  <Form.Control type="date" name="receipt_date" value={form.receipt_date} onChange={handleChange} isInvalid={!!errors.receipt_date}/>
                  <Form.Control.Feedback type="invalid">  {errors.receipt_date} </Form.Control.Feedback>
                </Form.Group>
               
                <Form.Group className="col-md-2 mb-3">
                    <Form.Label className='fs-5 text-dark'>Event Type<span className="text-danger fs-4"> * </span></Form.Label>
                    <Form.Select name="event_type" value={form.event_type} onChange={handleChange} isInvalid={!!errors.event_type}>
                      <option value="">Select</option>
                      {dropdownData.eventType.map((eventType) => (
                        <option key={eventType.type} value={eventType.type}>
                          {eventType.type}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">  {errors.event_type} </Form.Control.Feedback>
                  </Form.Group>

                  {/* <Form.Group className="col-md-2 mb-3">
                    <Form.Label className='fs-5 text-dark'>Participant Type<span className="text-danger fs-4"> * </span></Form.Label>
                    <Form.Control type="text" name="participant_type" value={form.participant_type} onChange={handleChange} isInvalid={!!errors.participant_type}/>
                    <Form.Control.Feedback type="invalid">  {errors.participant_type} </Form.Control.Feedback>
                  </Form.Group>
                 */}
                <Form.Group className="col-md-3 mb-3">
                <Form.Label className='fs-5 text-dark'>Payment Mode<span className="text-danger fs-4"> * </span></Form.Label>
                <Form.Control className="form-select mb-3" as="select" name="payment_type" value={form.payment_type} onChange={handleChange} isInvalid={!!errors.payment_type}>
                    <option value="">Select</option>
                    {dropdownData.paymentType.map((paymentType) => (
                        <option key={paymentType.type} value={paymentType.code}>
                        {paymentType.type}
                        </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">  {errors.payment_type} </Form.Control.Feedback>
                </Form.Group>
                </div>
                <div className='row'>
                <div className="col-md-12">
                    <h5>Billing Address</h5>
                </div>
                </div>
                <div class="row">
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label className='fs-5 text-dark'>Full Name <span className="text-danger fs-4"> * </span></Form.Label>
                  <Form.Control type="text" name="billing_full_name" value={form.billing_full_name} onChange={handleChange} isInvalid={!!errors.billing_full_name}/>
                  <Form.Control.Feedback type="invalid">  {errors.billing_full_name} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label className='fs-5 text-dark'>Email <span className="text-danger fs-4"> * </span></Form.Label>
                  <Form.Control type="email" name="billing_email" value={form.billing_email} onChange={handleChange} isInvalid={!!errors.billing_email}/>
                  <Form.Control.Feedback type="invalid">  {errors.billing_email} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label className='fs-5 text-dark'>Phone No <span className="text-danger fs-4"> * </span></Form.Label>
                  <Form.Control type="text" name="billing_phone_no" value={form.billing_phone_no} onChange={handleChange} isInvalid={!!errors.billing_phone_no}/>
                  <Form.Control.Feedback type="invalid">  {errors.billing_phone_no} </Form.Control.Feedback>
                </Form.Group>          
                <Form.Group className="col-md-4 mb-3">
                <Form.Label className='fs-5 text-dark'>Choose the Country <span className="text-danger fs-4"> * </span></Form.Label>
                <Form.Control className="form-select mb-3" as="select" name="billing_countries" value={form.billing_countries} onChange={handleChange} isInvalid={!!errors.billing_countries}>
                    <option value="">Select</option>
                    {dropdownData.countries.map((countries) => (
                        <option key={countries.code} value={countries.code}>
                        {countries.name}
                        </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">  {errors.billing_countries} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-8 mb-3">
                  <Form.Label className='fs-5 text-dark'>Address <span className="text-danger fs-4"> * </span></Form.Label>
                  <Form.Control type="text" name="billing_address" value={form.billing_address} onChange={handleChange} isInvalid={!!errors.billing_address}/>
                  <Form.Control.Feedback type="invalid">  {errors.billing_address} </Form.Control.Feedback>
                </Form.Group>
                </div>
                <div className='row'>
                <div className="col-md-12">
                    <h5>Shipping Address</h5>
                </div>
                </div>
 
                <Form.Group className="col-md-12 mb-3">
                <Form.Check
                  type="switch"
                  id="shipping-toggle"
                  label="Use Different Shipping Address"
                  checked={form.shipping}
                  onChange={handleShippingToggle}
                  />
                  </Form.Group>
 
                    {/* Conditionally Show Shipping Fields */}
                    {Boolean(form.shipping) === true && (
                    <div className="row">
                        <Form.Group className="col-md-4 mb-3">
                        <Form.Label className='fs-5 text-dark'>Full Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="shipping_full_name"
                            value={form.shipping_full_name}
                            onChange={handleChange} isInvalid={!!errors.shipping_full_name}
                        />
                       <Form.Control.Feedback type="invalid">  {errors.shipping_full_name} </Form.Control.Feedback>
                        </Form.Group>
 
                        <Form.Group className="col-md-4 mb-3">
                        <Form.Label className='fs-5 text-dark'>Email</Form.Label>
                        <Form.Control
                            type="text"
                            name="shipping_email"
                            value={form.shipping_email}
                            onChange={handleChange} isInvalid={!!errors.shipping_email}
                        />
                        <Form.Control.Feedback type="invalid">  {errors.shipping_email} </Form.Control.Feedback>
                        </Form.Group>
 
                        <Form.Group className="col-md-4 mb-3">
                        <Form.Label className='fs-5 text-dark'>Phone No</Form.Label>
                        <Form.Control
                            type="text"
                            name="shipping_phone_no"
                            value={form.shipping_phone_no}
                            onChange={handleChange} isInvalid={!!errors.shipping_phone_no}
                        />
                        <Form.Control.Feedback type="invalid">  {errors.shipping_phone_no} </Form.Control.Feedback>
                        </Form.Group>
 
                        <Form.Group className="col-md-4 mb-3">
                        <Form.Label className='fs-5 text-dark'>Choose the Country</Form.Label>
                        <Form.Control
                            className="form-select mb-3"
                            as="select"
                            name="shipping_countries"
                            value={form.shipping_countries}
                            onChange={handleChange} isInvalid={!!errors.shipping_countries}
                        >
                            <option value="">Select</option>
                            {dropdownData.countries.map((country) => (
                            <option key={country.code} value={country.code}>
                                {country.name}
                            </option>
                            ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">  {errors.shipping_countries} </Form.Control.Feedback>
                        </Form.Group>
 
                        <Form.Group className="col-md-4 mb-3">
                        <Form.Label className='fs-5 text-dark'>Address</Form.Label>
                        <Form.Control
                            type="text"
                            name="shipping_address"
                            value={form.shipping_address}
                            onChange={handleChange} isInvalid={!!errors.shipping_address}
                        />
                        <Form.Control.Feedback type="invalid">  {errors.shipping_address} </Form.Control.Feedback>
                        </Form.Group>
                    </div>
                    )}
                <div className='row'>
                <div className="col-md-12">
                    <h5>Payment Description</h5>
                </div>
                </div>
 
                <div className='row'>
                <Form.Group className="col-md-3 mb-3">
                  <Form.Label className='fs-5 text-dark'>Date of Payment <span className="text-danger fs-4"> * </span></Form.Label>
                  <Form.Control type="date" name="date_of_payment" value={form.date_of_payment} onChange={handleChange} isInvalid={!!errors.date_of_payment}/>
                  <Form.Control.Feedback type="invalid">  {errors.date_of_payment} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                <Form.Label className='fs-5 text-dark'>Choose the Currency <span className="text-danger fs-4"> * </span></Form.Label>
                <Form.Control className="form-select mb-3" as="select" name="currency_type" value={form.currency_type} onChange={handleChange} isInvalid={!!errors.currency_type}>
                    <option value="">Select</option>
                    {dropdownData.currencyType.map((currencyType) => (
                        <option key={currencyType.type} value={currencyType.type}>
                        {currencyType.type}
                    </option>
                ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">  {errors.currency_type} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                  <Form.Label className='fs-5 text-dark'>Registration Amount <span className="text-danger fs-4"> * </span></Form.Label>
                  <Form.Control type="number" name="reg_amount" value={form.reg_amount} onChange={handleChange} isInvalid={!!errors.reg_amount}/>
                  <Form.Control.Feedback type="invalid">  {errors.reg_amount} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                  <Form.Label className='fs-5 text-dark'>No. of Ticket <span className="text-danger fs-4"> * </span></Form.Label>
                  <Form.Control type="number" name="no_of_ticket" value={form.no_of_ticket} onChange={handleChange} isInvalid={!!errors.no_of_ticket}/>
                  <Form.Control.Feedback type="invalid">  {errors.no_of_ticket} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                <Form.Label className='fs-5 text-dark'>Registration Type <span className="text-danger fs-4">*</span></Form.Label>
                <Form.Control className="form-select mb-3" as="select" name="reg_type" value={form.reg_type} onChange={handleChange} isInvalid={!!errors.reg_type}>
                    <option value="">Select</option>
                    {dropdownData.regType.map((regtype) => (
                        <option key={regtype.type} value={regtype.type}>
                        {regtype.type}
                    </option>
                ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">  {errors.reg_type} </Form.Control.Feedback>
                </Form.Group>
               {/* Conditionally render the Registration Category field */}
              <Form.Group className="col-md-8 mb-3">
                <Form.Label className='fs-5 text-dark' style={{ display: showCategoryDropdown ? "block" : "none" }}>
                  Registration Category
                </Form.Label>
                <Form.Control
                  className="form-select mb-3"
                  as="select"
                  name="reg_category"
                  value={form.reg_category}
                  onChange={handleChange}
                  isInvalid={!!errors.reg_category}
                  style={{ display: showCategoryDropdown ? "block" : "none" }}
                >
                  <option value="">Select</option>
                  {filteredRegistrationCategories.map((category) => (
                    <option key={category.id} value={category.category}>
                      {category.category}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">{errors.reg_category}</Form.Control.Feedback>
              </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                <Form.Label className='fs-5 text-dark'>Accommodation</Form.Label>
                <Form.Check
                    type="switch"
                    id="accommodation-switch"
                    label={form.accommodation ? "Accommodation" : "Accommodation"}
                    checked={form.accommodation}  // Consistent as string
                    onChange={(e) => {
                        const isChecked = e.target.checked;
                        setForm((prevForm) => ({
                        ...prevForm,
                        accommodation: isChecked, // Store as string
                        accommodation_status: isChecked ? "" : "", // Clear if false
                        occupancy_type: isChecked ? "" : "",        // Clear if false
                        total_no_of_nights: isChecked ? "" : ""     // Clear if false
                        }));
                    }}
                    />
                </Form.Group>
              {/* {Boolean(form.accommodation)} */}
                {Boolean(form.accommodation) === true && (
                  <>
                    <Form.Group className="col-md-3 mb-3">
                      <Form.Label className='fs-5 text-dark'>Accommodation Status</Form.Label>
                      <Form.Select
                        name="accommodation_status"
                        value={form.accommodation_status}
                        onChange={handleChange} isInvalid={!!errors.accommodation_status}
                      >
                        <option value="">-- Select --</option>
                        <option value="paid">Paid</option>
                        <option value="free">Free</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">  {errors.accommodation_status} </Form.Control.Feedback>
                    </Form.Group>
 
                    <Form.Group className="col-md-3 mb-3">
                      <Form.Label className='fs-5 text-dark'>Occupancy</Form.Label>
                      <Form.Control
                        className="form-select mb-3"
                        as="select"
                        name="occupancy_type"
                        value={form.occupancy_type}
                        onChange={handleChange} isInvalid={!!errors.occupancy_type}
                      >
                        <option value="">Select</option>
                        {dropdownData.occupancyType.map((occupancyType) => (
                          <option key={occupancyType.type} value={occupancyType.type}>
                            {occupancyType.type}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">  {errors.occupancy_type} </Form.Control.Feedback>
                    </Form.Group>
 
                    <Form.Group className="col-md-3 mb-3">
                      <Form.Label className='fs-5 text-dark'>No. of Nights</Form.Label>
                      <Form.Control
                        type="text"
                        name="total_no_of_nights"
                        value={form.total_no_of_nights}
                        onChange={handleChange} isInvalid={!!errors.total_no_of_nights}
                      />
                     <Form.Control.Feedback type="invalid">  {errors.total_no_of_nights} </Form.Control.Feedback>
                    </Form.Group>
                  </>
                )}
                </div>              
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
              <Button variant="primary" onClick={handleSubmit}> {modalType === 'add' ? 'Add' : 'Save'} </Button>
            </Modal.Footer>
          </Modal>
 
          {/* Delete Confirmation Modal */}
          {/* <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this row?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal> */}
        </div>
        <Footer />
        </div>
      )};
      </div>
    </div>
  );
};
 
export default PaymentReceipt;